"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _FilePickerModal = require("./FilePickerModal");
Object.keys(_FilePickerModal).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _FilePickerModal[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _FilePickerModal[key];
    }
  });
});